import configs from '@/config'

/**
 * PostMessage Events Configuration for AI Chatbot
 * Manages cross-origin messaging with AI Chatbot app
 */

// PostMessage Event Types
export const POST_MESSAGE_EVENTS = {
  AI_IMPORT_REQUEST: 'AI_IMPORT_REQUEST',
}

// AI Chatbot Origins - matches the URL construction in ai-chatbot.module.js
export const ALLOWED_ORIGINS = {
  AI_CHATBOT: {
    // Get target origin matching the AI Chatbot URL construction
    getTargetOrigin() {
      if (!configs.aiAppUrl) {
        return null
      }
      try {
        return new URL(configs.aiAppUrl).origin
      } catch {
        // A misconfigured non-absolute value (legacy bare-hostname) would throw; degrade to null.
        return null
      }
    },
    // Get AI Chatbot iframe window reference. PRO7-88: the container can hold two
    // iframes (unified /sandbox + legacy Slide overlay), one shown via `v-show`;
    // target the VISIBLE one. `v-show` sets display:none on the wrapper DIV not the
    // inner <iframe>, so walk ancestors for an inline display:none (offsetParent is
    // null on the fixed container). Falls back to the first iframe.
    getTargetWindow() {
      const globalChatbotContainer = document.querySelector('.global-chatbot-container')
      if (!globalChatbotContainer) {
        return null
      }

      const iframes = Array.from(globalChatbotContainer.querySelectorAll('iframe'))
      if (iframes.length === 0) {
        return null
      }

      const isHiddenByVShow = (iframe) => {
        let node = iframe
        // Inclusive of the container itself; stop once we step above it.
        while (node && node !== globalChatbotContainer.parentNode) {
          if (node.style && node.style.display === 'none') {
            return true
          }
          node = node.parentElement
        }
        return false
      }

      const visibleIframe = iframes.find((frame) => !isHiddenByVShow(frame))
      const targetIframe = visibleIframe || iframes[0]
      return targetIframe?.contentWindow || null
    },
  },
}

export default {
  POST_MESSAGE_EVENTS,
  ALLOWED_ORIGINS,
}
